module.exports = __webpack_public_path__ + "img/fieldpic-tit.d9dfeda2.png";